import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetTenantData } from '../../../Redux/Reducer/SelfServe';
import ClientCard from './ClientCard';

const Client = ({
  searchVal = '',
  liveOnly = true,
  setTenantId,
  setTenantName
}) => {
  const [searchedRes, setSearchRes] = useState([]);
  const dispatch = useDispatch();
  const clientsList = useSelector(state => state.SelfServe.clientsList);

  useEffect(() => {
    let filtered = clientsList;
    if (liveOnly) {
      filtered = filtered.filter(client => client?.is_live);
    }
    if (searchVal) {
      filtered = filtered.filter(
        client =>
          client?.name?.includes(searchVal) ||
          client?.name?.toLowerCase()?.includes(searchVal)
      );
    }
    const sorted = [...filtered].sort((a, b) =>
      (a?.name || '').localeCompare(b?.name || '')
    );
    setSearchRes(sorted);
  }, [clientsList, searchVal, liveOnly]);

  const handleClientCardClick = (tenantId, name) => {
    dispatch(resetTenantData());
    setTenantId(tenantId);
    setTenantName(name);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(278px, 1fr))',
        gap: 2,
        py: 2,
        maxHeight: 'calc(100vh - 180px)',
        overflow: 'auto'
      }}
    >
      {searchedRes.map(
        clientInfo =>
          clientInfo?.name && (
            <ClientCard
              {...{ ...clientInfo, handleClientCardClick }}
              key={clientInfo?.id}
            />
          )
      )}
    </Box>
  );
};

export default Client;
